module.exports = __webpack_public_path__ + "static/media/flutter.48facc19.png";